import type { ReactNode } from 'react';
import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';

export function Center({
  children,
  css,
  isFullScreen = false,
}: {
  children: ReactNode;
  css?: CSS;
  isFullScreen?: boolean;
}) {
  return (
    <Container css={css} isFullScreen={isFullScreen}>
      {children}
    </Container>
  );
}

const Container = styled('div', {
  variants: {
    isFullScreen: {
      true: {
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
      },
    },
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
